export default {
  text: {
    en: `
    Dear {firstName},
    <br /><br />
    Sorry! You can’t add the same product twice. Scentbird is a discovery
    platform to help you find new products. Please choose another product,
    try something new that will delight you!
    <br /><br />
    You can order the same product again every <b>6 months</b>.
  `,
  },
}
